<template>
  <div>
    <v-snackbar class="snakbar-sty rounded-pill" transition="slide-x-reverse-transition" v-model="snackbar" :timeout="3000" :value="true" :color="snackbarclr" absolute outlined>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <div class="body-row pb-3 px-4 px-md-6 px-lg-8 pt-lg-6">
      <zebu-logo />
      <v-card class="elevation-0">
        <p class="mynt-eyebrow font-weight-bold mb-2">Welcome to Zebu</p>
        <p class="mynt-title font-weight-bold mb-7">Forgot Password</p>

        <div>
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
            <v-text-field :disabled="valdatadis" v-model="userId" :rules="useridRules" color="#0037B7" class="mynt-field mb-3" label="Client ID" required oninput="this.value = this.value.toUpperCase()"></v-text-field>

            <v-text-field
              :disabled="valdatadis"
              v-model="pan"
              :append-icon="paneye ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="panRules"
              :type="paneye ? 'text' : 'password'"
              color="#0037B7"
              class="mynt-field mb-3"
              label="PAN"
              @click:append="paneye = !paneye"
              required
              oninput="this.value = this.value.toUpperCase()"
            ></v-text-field>

            <v-text-field :disabled="valdatadis" v-model="dob" :rules="dobRules" color="#0037B7" class="mynt-field mb-3" label="Date of birth (DDMMYYYY)" type="number" required hide-spin-buttons></v-text-field>

            <div class="mt-4" :style="`cursor: ${valid != true ? 'not-allowed' : 'auto'};`">
              <v-btn height="47px" :disabled="!valid" type="submit" color="#0037B7" class="text-none mynt-btn elevation-0 mb-1" block> <span class="white--text mynt-btn-label">Unblock & Reset</span></v-btn>
            </div>

            <p class="mb-0 mt-3">
              <v-row no-gutters>
                <v-col cols="5" class="text-left pr-3">
                  <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="backtoMyntin()">
                    <span class="mynt-link text-none"> Back to login </span>
                  </v-btn>
                </v-col>
                <v-col cols="7" class="text-right">
                  <v-list-item-title>
                    <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="changePws()">
                      <span class="mynt-link text-none"> Change password</span>
                    </v-btn></v-list-item-title
                  >
                </v-col>
              </v-row>
            </p>
          </v-form>
          <p class="mynt-signup mb-0 text-center mt-6">Don't have an account yet? <a class="mynt-link" style="text-decoration: none" href="https://oa.mynt.in?ref=desk">Sign Up</a></p>
        </div>
      </v-card>
      <v-footer padless absolute color="#fff">
        <v-col class="text-center font-weight-medium fs-13 px-lg-8 px-md-6 px-lg-8 pb-2 mynt-legal" cols="12"
          ><span class="font-weight-bold fs-14 black--text"> Zebu Share and Wealth Managements Pvt. Ltd. </span><br />
          SEBI Registration No: INZ000174634 | NSE : 13179 | BSE : 6550 | MCX : 55730 | CDSL : 12080400 | AMFI ARN : 113118 | Research Analyst : INH200006044
        </v-col>
      </v-footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mynturl} from "../../apiUrl.js";
import ZebuLogo from "../../components/ZebuLogo.vue";

export default {
  components: {ZebuLogo},

  data: () => ({
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    valdatadis: false,
    valid: true,
    userId: "",
    useridRules: [(v) => !!v || "Client Id is required"],
    dob: "",
    dobRules: [(v) => !!v || "Date of birth is required", (v) => /[0-3]{1}[0-9]{1}[0-1]{1}[0-9]{1}[0-9]{4}$/.test(v) || "Date of birth must be [DDMMYYYY eg: 01012000]", (v) => v.length == 8 || "Date of birth must be valid"],
    paneye: false,
    pan: "",
    panRules: [(v) => !!v || "PAN is required", (v) => /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) || "PAN number must be valid"],
    theme: "Light",
  }),

  async created() {
    this.theme = "Dark";
  },

  mounted() {
    this.actid = localStorage.getItem("actid");
    if (this.actid != null) {
      this.userId = this.actid;
    } else {
      this.userId = "";
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.$refs.form.validate() != false) {
        var axiosThis = this;
        var data = `jData={"uid":"${this.userId}","pan":"${this.pan}","dob":"${this.dob}"}`;
        var config = {
          method: "post",
          url: `${mynturl}/ForgotPassword`,
          headers: {
            "Content-Type": "text/plain",
            Cookie: "NWC_ID=3e03100f85c0155ffb62d5d9bcc0ee273e804c489e430ddb9e00eda1aab50f54",
          },
          data: data,
        };
        // console.log("pandob data", data);
        axios(config)
          .then(function (response) {
            // // console.log(JSON.stringify(response.data));
            // console.log("pandob", response.data);
            if (response.data.emsg == "Error Occurred : Wrong user id or user details") {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              axiosThis.snackmsgbar = "Invalid User or Invalid Client ID";
              axiosThis.userId = "";
              axiosThis.dob = "";
              axiosThis.pan = "";
            } else if (response.data.stat == "Ok") {
              axiosThis.valdatadis = true;
              localStorage.setItem("FgotPwduserid", axiosThis.userId);
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#22ab94";
              axiosThis.snackmsgbar = "New password is send through email/SMS.";
              localStorage.removeItem("ylisft");
              localStorage.removeItem("actid");
              localStorage.removeItem("email");
              // localStorage.removeItem("loginway");
              localStorage.removeItem("susertoken");
              setTimeout(function () {
                axiosThis.$router.push("/change_password");
              }, 2000);
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              if (response.data.emsg) {
                axiosThis.snackmsgbar = response.data.emsg;
              } else {
                axiosThis.snackmsgbar = "something went wrong, Kindly try again.";
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    backtoMyntin() {
      this.$router.push("/sso");
    },
    changePws() {
      this.$router.push("/Change_Password");
    },
  },
};
</script>
